module.exports = __webpack_public_path__ + "static/media/зи.ccf4c6a7.mp3";